import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const TickOutlineIcon = createIcon({
  displayName: 'TickOutlineIcon',
  path: [
    <path
      d='M5 12.25C5 8.24594 8.24594 5 12.25 5C16.2541 5 19.5 8.24594 19.5 12.25C19.5 16.2541 16.2541 19.5 12.25 19.5C8.24594 19.5 5 16.2541 5 12.25Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    <path
      d='M9.5 12.5L11 14.5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    <path
      d='M15.5 10L11 14.5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  ],
  defaultProps: defaultProps
})
